export default {
  header: {
    text1: "home",
    text2: "Política privacidad",
  },
  home: {
    text1: "Company Profile",
    text2:
      "BULANADESIXINGGONG ES UNA EMPRESA MINORISTA INTEGRAL QUE SE CENTRA EN LA VENTA MINORISTA DE COMESTIBLES, SUMINISTROS ORTOPÉDICOS, PEQUEÑOS ELECTRODOMÉSTICOS Y EQUIPOS DE ELECTRODOMÉSTICOS. Estamos comprometidos a proporcionar necesidades diarias de alta calidad, soluciones para el cuidado de la salud y electrodomésticos inteligentes para usuarios domésticos, satisfaciendo las necesidades integrales de los consumidores, desde las compras diarias hasta la gestión de la salud, desde la cocina conveniente hasta el hogar cómodo.",
    text3:
      "Con años de experiencia en la industria, nos hemos convertido en un proveedor confiable de servicios de vida en el hogar, con productos de alta calidad, precios razonables y un servicio considerado, hemos ganado el reconocimiento de la mayoría de los consumidores.",
  },
  footer: {
    contactUs: "Contact Us",
    email: "Buzón: ",
    serviceHours: "Customer Service Hours: ",
    address: "Dirección: ",
    companyName: 'Nombre de la empresa: ',
    tel: 'Teléfono: '
  },
};
